import { createSlice } from '@reduxjs/toolkit';

export const policyMgtSlice = createSlice({
    name: 'policyMgt',
    initialState: {
        currentPolicy: null,
    },
    reducers: {
        setCurrentPolicy: (state, action) => {
            state.currentPolicy = action.payload;
        },
        clearCurrentPolicy: (state) => {
            state.currentPolicy = null;
        },
    },
});

export const {
    setCurrentPolicy,
    clearCurrentPolicy,
} = policyMgtSlice.actions;

export const getCurrentPolicy = (state) => state.policyMgt.currentPolicy;

export default policyMgtSlice.reducer;
